export const industryDetails = [
  {
    id: 'manufacturing',
    title: 'Manufacturing',
    summary: 'Gearbox and hydraulic repair support for production lines, plant equipment, and mechanical systems.',
    icon: '/icons/manufacturing.svg',
    image: '/images/industries/manufacturing.jpg',
    needs: ['Reducers and gearboxes', 'Hydraulic cylinders', 'Drive components', 'Production equipment repair'],
  },
  {
    id: 'material-handling',
    title: 'Material Handling',
    summary: 'Repair support for hydraulic and drive components used in lifting, moving, loading, and handling equipment.',
    icon: '/icons/material-handling.svg',
    image: '/images/industries/material-handling.jpg',
    needs: ['Lift equipment hydraulics', 'Conveyor drive components', 'Gear reducers', 'Cylinder repair and rebuilding'],
  },
  {
    id: 'heavy-equipment',
    title: 'Construction',
    summary: 'Hydraulic and mechanical repair support for heavy-use equipment working in demanding environments.',
    icon: '/icons/construction.svg',
    image: '/images/industries/construction.jpg',
    needs: ['Hydraulic cylinders', 'Mechanical assemblies', 'Drive components', 'Worn or damaged equipment parts'],
  },
  {
    id: 'agriculture',
    title: 'Agriculture',
    summary: 'Repair planning for hydraulic and gearbox equipment used in agricultural and processing applications.',
    icon: '/icons/agriculture.svg',
    image: '/images/industries/agriculture.jpg',
    needs: ['Hydraulic cylinder repair', 'Gearbox repair', 'Seals and wear components', 'Equipment downtime support'],
  },
  {
    id: 'energy',
    title: 'Energy',
    summary: 'Gearbox and hydraulic repair support for industrial equipment, components, and drive systems.',
    icon: '/icons/energy.svg',
    image: '/images/industries/energy.jpg',
    needs: ['Gearbox inspection', 'Hydraulic repair', 'Mechanical component review', 'Repair versus replacement guidance'],
  },
];

export const industryProblems = [
  'Unexpected downtime',
  'Leaking hydraulic cylinders',
  'Gearbox noise or vibration',
  'Overheating drive components',
  'Pressure loss or weak movement',
  'Worn bearings, seals, shafts, or mounting points',
];
